import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';

import App from './App';
import reportWebVitals from './reportWebVitals';
import rum from '@/plugins/rum';

rum.init?.();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const release = process.env.GIT_HASH;
const environment = process.env.PROJECT_ENV;
const time = process.env.BUILD_TIME ? dayjs(Number(process.env.BUILD_TIME)).format('YYYY.MM.DD HH:mm') : process.env.BUILD_TIME;
/** 初始化打印信息 */
console.log('==>projectInfo: gitHash:%s, environment:%s, buildTime:%s', release, environment, time);
